module.exports = __webpack_public_path__ + "img/iphone-x-shadow.b466b02.png";